var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccLoans(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#E4F2E6",
    style: (_ref2 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5272 58.0758H28.4502C27.7361 58.0758 27.0513 57.7921 26.5464 57.2872C26.0415 56.7823 25.7578 56.0975 25.7578 55.3834V33.8447C25.7578 33.1306 26.0415 32.4458 26.5464 31.9409C27.0513 31.436 27.7361 31.1523 28.4502 31.1523H60.7582C61.4723 31.1523 62.1571 31.436 62.662 31.9409C63.1669 32.4458 63.4506 33.1306 63.4506 33.8447V41.9217",
    stroke: "#277154",
    style: (_ref3 = {
      stroke: "#277154"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5156 44.622C36.5156 43.908 36.7993 43.2232 37.3042 42.7183C37.8091 42.2133 38.4939 41.9297 39.208 41.9297H71.5161C72.2301 41.9297 72.9149 42.2133 73.4198 42.7183C73.9247 43.2232 74.2084 43.908 74.2084 44.622V66.1608C74.2084 66.8748 73.9247 67.5596 73.4198 68.0645C72.9149 68.5694 72.2301 68.8531 71.5161 68.8531H39.208C38.4939 68.8531 37.8091 68.5694 37.3042 68.0645C36.7993 67.5596 36.5156 66.8748 36.5156 66.1608V44.622Z",
    stroke: "#277154",
    style: (_ref4 = {
      stroke: "#277154"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 55.3964C49.9922 56.8245 50.5595 58.1941 51.5693 59.2039C52.5791 60.2138 53.9488 60.7811 55.3769 60.7811C56.805 60.7811 58.1746 60.2138 59.1844 59.2039C60.1942 58.1941 60.7616 56.8245 60.7616 55.3964C60.7616 53.9683 60.1942 52.5987 59.1844 51.5889C58.1746 50.579 56.805 50.0117 55.3769 50.0117C53.9488 50.0117 52.5791 50.579 51.5693 51.5889C50.5595 52.5987 49.9922 53.9683 49.9922 55.3964Z",
    stroke: "#277154",
    style: (_ref5 = {
      stroke: "#277154"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccLoans);
export default __webpack_public_path__ + "static/media/AccLoans.88bdeb5e.svg";
export { ForwardRef as ReactComponent };